/*
 * Copyright © 2025 Gavin Sawyer. All rights reserved.
 */

export const twilioAccountSid: string = "ACb2d6f8364170931563326345ee365d2b" as string;
